function IconHandLuggageAvailable(props) {
	return (
		<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
			<path
				d="M16.0397 18.9922C19.8005 18.9923 23.1341 20.1722 25.4088 21.9912V25.3408C25.4088 27.1775 23.9202 28.667 22.0836 28.667H9.99181C8.15526 28.667 6.66563 27.1775 6.66563 25.3408V21.9941C8.94048 20.1734 12.2766 18.9922 16.0397 18.9922ZM16.0367 2.66699C18.541 2.66699 20.5717 4.6968 20.5719 7.20117V7.46387C23.456 9.06178 25.4088 12.1361 25.4088 15.667V19.7627C22.8802 18.1396 19.5961 17.1788 16.0397 17.1787C12.4814 17.1787 9.19485 18.1401 6.66563 19.7646V15.667C6.66563 12.1364 8.6189 9.06289 11.5025 7.46484V7.20117C11.5028 4.6969 13.5326 2.66717 16.0367 2.66699ZM13.6188 14.1553H18.4557V12.3408H13.6188V14.1553ZM16.0367 4.48047C14.7118 4.48062 13.6091 5.4283 13.3668 6.68262C14.2133 6.43131 15.1096 6.29492 16.0377 6.29492C16.9652 6.29494 17.8606 6.4316 18.7066 6.68262C18.4643 5.42825 17.3618 4.48047 16.0367 4.48047Z"
				fill="currentColor"
			/>
		</svg>
	);
}

export default IconHandLuggageAvailable;
